import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import assetsPath from '../../constant.js';

/**
 * Nordnet gamme offer atom. Used in gammes molecule.
 *
 * imageSrc - The mobile button href.
 * title - The mobile button text.
 * subTitle - The mobile button text.
 */
@customElement('nn-card-gamme')
export class CardGamme extends LitElement {
  static styles = css`
    body {
      margin: 0;
      padding: 0;
    }

    .figure {
      align-items: center;
      background: var(--nn-card-gamme_figure_background, #f7f7f6);
      border-radius: var(--nn-card-gamme_figure_border-radius, 16px);
      box-sizing: border-box;
      display: flex;
      gap: var(--nn-card-gamme_figure_gap, 10px);
      justify-content: flex-start;
      margin: 0;
      padding: var(--nn-card-gamme_figure_padding, 12px 20px);
      width: 100%;
    }

    .figure--image {
      align-items: center;
      display: flex;
      justify-content: center;
    }

    .figcaption {
      color: var(--nn-card-gamme_figcaption_color, #010101);
    }

    .figcaption--title {
      font-family: 'font-medium';
      font-size: var(--nn-card-gamme_figcaption--title_font-size, 16px);
      line-height: calc(2px + 2ex);
      text-align: left;
    }

    .figcaption--subtitle {
      font-family: 'font-light';
      font-size: var(--nn-card-gamme_figcaption--subtitle_font-size, 12px);
      line-height: calc(4px + 2ex);
      white-space: nowrap;
    }
  `;

  @property({ type: String }) imageSrc = '';

  @property({ type: String }) title = '';

  @property({ type: String }) subTitle = '';

  render() {
    return html`
      <figure class="figure">
        <div class="figure--image">
          <img
            class="img-responsive"
            src="${assetsPath}/icons/${this.imageSrc}"
            alt=""
            width="32"
            height="32"
          />
        </div>
        <figcaption class="figcaption">
          <div class="figcaption--title">${this.parseHtml(this.title)}</div>
          <div class="figcaption--subtitle">
            ${this.subTitle
              ? html` <div>${this.parseHtml(this.subTitle)}</div>`
              : html``}
          </div>
        </figcaption>
      </figure>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  parseHtml(str?: any) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
}
